import { useEffect, useState } from 'react'

const BounceCountdown = ({ resetTime }) => {
  const [timeLeft, setTimeLeft] = useState(null)

  useEffect(() => {
    if (!resetTime) {
      setTimeLeft('Waiting for game to start...')
      return
    }

    const updateCountdown = () => {
      const now = Date.now()
      const remaining = resetTime - now

      if (remaining <= 0) {
        setTimeLeft('Resetting...')
      } else {
        const minutes = Math.floor(remaining / 60000)
        const seconds = Math.floor((remaining % 60000) / 1000)
        setTimeLeft(`${minutes}:${seconds.toString().padStart(2, '0')}`)
      }
    }

    updateCountdown()
    const interval = setInterval(updateCountdown, 1000)

    return () => clearInterval(interval)
  }, [resetTime])

  if (!timeLeft) {
    return null
  }

  return (
    <div style={{
      padding: '10px 15px',
      backgroundColor: '#fff3cd',
      border: '2px solid #ffc107',
      borderRadius: '8px',
      marginBottom: '10px',
      textAlign: 'center'
    }}>
      <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>
        ⏱️ Game Reset In
      </div>
      <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#856404' }}>
        {timeLeft}
      </div>
    </div>
  )
}

export default BounceCountdown
